import { Truck } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { MaterialPickupPage } from './pages/MaterialPickupPage'
import { MaterialPickupDetailPage } from './pages/MaterialPickupDetailPage'

/**
 * Material Pickup Inbox (2026-06-15).
 *
 * Command & control for inbound vendor shipments. Vendors send pickup
 * requests to purchasing@siliconesplus.com; CARLA stages them here,
 * extracts PO references and logistics details, and alerts Ryan Norris
 * via Discuss DM. The purchasing team drives cards through a 6-stage
 * pipeline (New Request → Received) and manages handoff to the PO in
 * Odoo.
 *
 * Permissions: admin + operations (full access) + purchasing (new role,
 * view + edit, no confirm gate needed — this is logistics tracking).
 */
export default defineModule({
  id: 'material-pickup',
  name: 'Material Pickup',
  shortName: 'Pickups',
  icon: Truck,
  navSection: 'logistics',
  navOrder: 20,
  urlNamespace: '/material-pickup',
  routes: [
    { path: '/', element: MaterialPickupPage, label: 'Material Pickup Inbox' },
    {
      path: '/$pickupId',
      element: MaterialPickupDetailPage,
      label: 'Pickup detail',
    },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g y',

  commandPaletteEntries: [
    {
      label: 'Go to Material Pickup Inbox',
      keywords: [
        'material',
        'pickup',
        'vendor',
        'shipment',
        'inbound',
        'receiving',
        'purchasing',
        'po',
        'freight',
      ],
      path: '/',
      group: 'modules',
      shortcut: 'g y',
    },
  ],
})
